import React, {Component} from 'react';
import {Link} from "react-router-dom";
import {LearnBox} from "./LearnBox";
import {LearnPage} from "./LearnPage";
import {LearnSection} from "./LearnSection";
import {getAppVersion} from "../services/AppVersionService";

export class About extends Component {
    static displayName = About.name;

    constructor(props) {
        super(props);
        this.state = {
            appVersion: null
        };
    }

    componentDidMount() {
        getAppVersion().then(data => this.setState({appVersion: data}));
    }

    render() {
        let serverTimeAgoString = "Ukendt";
        const serverModifiedTimeString = this.state.appVersion?.server.modifiedTime;
        if (serverModifiedTimeString) {
            const serverModifiedTime = Date.parse(serverModifiedTimeString);
            const seconds = Math.round((new Date().getTime() - serverModifiedTime) / 1000);
            serverTimeAgoString = seconds + " sekunder siden";
            if (seconds > 60) {
                const minutes = Math.round(seconds / 60);
                serverTimeAgoString = minutes + " minutter siden";
                if (minutes > 60) {
                    const hours = Math.round(minutes / 60);
                    serverTimeAgoString = hours + " timer siden";
                }
            }
        }
        const clientGitHash = this.state.appVersion && this.state.appVersion.server.gitHash === this.state.appVersion.client?.gitHash ?
            "Samme som server" : (this.state.appVersion?.client?.gitHash ?? "(ukendt)");
        return (
            <LearnPage title="Om">
                <LearnSection>
                    <LearnBox title="Formål">
                        <p>Fri læring for alle.</p>
                        <p>Sjove og motiverende opgaver.</p>
                        {this.state.appVersion == null ? null :
                            <div>
                                <p>Server app Git hash: {this.state.appVersion.server.gitHash}</p>
                                <p>Server app sidst ændret: {serverTimeAgoString}</p>
                                <p>Client app Git hash: {clientGitHash}</p>
                            </div>}
                    </LearnBox>
                    <LearnBox title="Historie">
                        <p>
                            Fri Læring med Leg er inspireret af mine børn som er sjove og gerne vil lære,
                            og af lichess.org som er fri og god til læring om skak.
                        </p>
                        <p>
                            Fri Læring med Leg er udviklet af Ole Lynge Sørensen i 2022.
                        </p>
                    </LearnBox>
                    <LearnBox title="Rulletekster">
                        <ul>
                            <li>Programmering: Ole Lynge Sørensen</li>
                            <li>Opgave-inspiration: Oles børn</li>
                            <li>App-inspiration: <a href="https://lichess.org">lichess.org</a>
                            </li>
                            <li>Calculator: <a href="https://github.com/madzadev/calculator">github/madzadev</a> +
                                <a href="https://www.sitepoint.com/react-tutorial-build-calculator-app/">blog</a>
                            </li>
                        </ul>
                    </LearnBox>
                </LearnSection>
                <LearnSection title="Privatliv">
                    <LearnBox title="Cookies">
                        <p>Vi gemmer ingen cookies, hverken på dette domæne eller på andre domæner.</p>
                        <p>Der laves ikke forespørgsler til andre domæner end dette.</p>
                    </LearnBox>
                    <LearnBox title="Data-politik">
                        <p>Vi gemmer ikke brugerspecifikt data på vores servere eller andres servere.</p>
                        <p>Vi gemmer statistik om hvilke opgaver der besvares rigtigt eller forkert, med henblik på at
                            forbedre opgaverne. Vi gemmer ingen information om hvilke brugere der har svaret rigtigt
                            eller forkert.</p>
                    </LearnBox>
                    <LearnBox title="Data i brugerens browser">
                        <p>I brugerens browser gemmes data om følgende:</p>
                        <ul>
                            <li>Brugerens rekord i opgave-stime.
                                Dette gør det muligt for brugeren at kæmpe mod sin egen rekord.
                            </li>
                        </ul>
                        <p>Det data der opbevares i brugerens browser sendes ikke til andre og kan ikke læses af andre
                            brugere.</p>
                        <p>Du kan se og slette data her:
                            <Link to="/profile">Profil</Link>
                        </p>
                    </LearnBox>
                </LearnSection>
            </LearnPage>
        );
    }
}
